export default "__VITE_ASSET__CV_ur4md__"